export default {
    rules: [],
    loadingRules: true
}